import { sendAction } from '@/core/action';


export function updateBrowserControlState(browserHasControl: boolean) {
  return sendAction({
    actionId: 'updateBrowserControlState',
    browserHasControl,
  });
}
